<div class="resonance-lps" [class.mirrored]="side() === 'design'">
  <h4 class="resonance-title">{{ title() }}</h4>

  <ul class="resonance-legend">
    @for (item of legendItems(); track item.kind) {
      <li class="legend-item" [attr.data-kind]="item.kind">
        @if (item.iconSrc; as iconSrc) {
          <img class="legend-icon" [src]="iconSrc" alt="" aria-hidden="true" />
        } @else {
          <span
            class="legend-swatch"
            [class.legend-swatch--vertical]="item.kind === 'vertical'"
            [class.legend-swatch--lateral]="item.kind === 'lateral'"
            aria-hidden="true"
          ></span>
        }
        <span class="legend-text">{{ item.text }}</span>
      </li>
    }
  </ul>

  <div class="lps-grid">
    @for (vertical of verticals(); track vertical.key; let colIndex = $index) {
      <div
        class="vertical-frame"
        aria-hidden="true"
        [style.grid-column]="colIndex + 1"
      ></div>
    }

    @for (lateral of laterals(); track lateral.row; let rowIndex = $index) {
      <div
        class="lateral-frame"
        aria-hidden="true"
        [style.grid-row]="rowIndex + 2"
      ></div>
    }

    @for (vertical of verticals(); track vertical.key; let colIndex = $index) {
      <div class="vertical-label" [style.grid-column]="colIndex + 1">
        {{ vertical.label }}
      </div>

      @for (block of vertical.blocks; track block.displayConfig.key; let rowIndex = $index) {
        <hd-planet-activation-block
          class="lps-block"
          [style.grid-column]="colIndex + 1"
          [style.grid-row]="rowIndex + 2"
          [activation]="block.activation"
          [displayConfig]="block.displayConfig"
          [colorConfig]="colorConfig()"
          [isDefined]="block.isDefined"
          [matchLines]="matchLines()"
          [profileLines]="profileLines()"
          [resonanceKeynote]="block.keynote"
          [resonanceKeynoteTooltip]="block.keynoteTooltip"
          [resonanceBaseNumber]="block.baseNumber"
          [resonanceBaseIconSrc]="block.baseIconSrc"
          [resonanceBaseTooltip]="block.baseTooltip"
          [resonanceBasePlacement]="baseSymbolPlacement"
          variant="grid"
          (blockClicked)="blockClicked.emit($event)"
        ></hd-planet-activation-block>
      }

      <div
        class="vertical-keynote"
        [style.grid-column]="colIndex + 1"
        [title]="vertical.description"
      >
        {{ vertical.keynote }}
      </div>
    }

    @for (lateral of laterals(); track lateral.row; let rowIndex = $index) {
      <div
        class="lateral-label"
        [class.lateral-label--has-tooltip]="lateral.tooltip"
        [style.grid-row]="rowIndex + 2"
        [title]="lateral.tooltip"
      >
        <span class="lateral-label__text">{{ lateral.label }}</span>
      </div>
    }

    <div class="prana-indicator">
      <span class="prana-out">
        <svg class="prana-arrow prana-arrow--out" viewBox="0 0 22 12" aria-hidden="true">
          <path d="M1 6 H18 M14 2 L20 6 L14 10" />
        </svg>
        <span class="prana-out__label">{{ pranaOutLabel() }}</span>
      </span>
      <span class="prana-word">{{ pranaWord() }}</span>
      <span class="prana-lateral">{{ lateralReactivityLabel() }}</span>
      <span class="prana-in">
        <span class="prana-in__label">{{ pranaInLabel() }}</span>
        <svg class="prana-arrow prana-arrow--in" viewBox="0 0 12 22" aria-hidden="true">
          <path d="M6 1 V18 M2 14 L6 20 L10 14" />
        </svg>
      </span>
      <span class="prana-vertical">
        @for (line of verticalShapingLines(); track $index) {
          <span class="prana-vertical__line">{{ line }}</span>
        }
      </span>
    </div>
  </div>
</div>
